import { render, staticRenderFns } from "./personnelPublicity.vue?vue&type=template&id=68e18292&"
import script from "./personnelPublicity.vue?vue&type=script&lang=js&"
export * from "./personnelPublicity.vue?vue&type=script&lang=js&"
import style0 from "./personnelPublicity.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports